import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../assets/raya-logo.PNG';
import './navbar.css';

const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false);

    return (
        <div className="sam__navbar">
            <div className="sam__navbar-links">
                <div className="sam__navbar-links_logo">
                    <img src={logo} />
                </div>
                <div className="sam__navbar-links_container" dir='rtl'>
                    <p><a href="#home">خانه</a></p>
                    <p><a href="#wsam">توسعه فناوران رایا</a></p>
                    <p><a href="#features">انواع خدمات ما</a></p>
                    <p><a href="#possibility">روش کار ما</a></p>
                    <p><a href="#blog">نمونه کارهای ما</a></p>
                    <p><a href="#footer">ارتباط باما</a></p>
                </div>
            </div>
            {/* <div className="sam__navbar-sign">
        <p>Sign in</p>
        <button type="button">Sign up</button>
      </div> */}
            <div className="sam__navbar-menu">
                {toggleMenu
                    ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
                    : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
                {toggleMenu && (
                    <div className="sam__navbar-menu_container scale-up-center">
                        <div className="sam__navbar-menu_container-links">
                            <p><a href="#home">خانه</a></p>
                            <p><a href="#wsam">توسعه فناوران رایا</a></p>
                            <p><a href="#features">انواع خدمات ما</a></p>
                            <p><a href="#possibility">روش کار ما</a></p>
                            <p><a href="#blog">نمونه کارهای ما</a></p>
                            <p><a href="#footer">ارتباط باما</a></p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Navbar;
